/* =========================
   RETAIL PRICE POPULATOR V5
   ========================= */
   (function () {
    // Guard
    if (window.__WOF_RETAIL_PROGRESSIVE_V5__) return;
    window.__WOF_RETAIL_PROGRESSIVE_V5__ = true;
  
    /************ CONFIG ************/
    const TARGET_TABLE = '#wof_product_table';
    const COLLECTION_BASE = '/collections/all-products';
    const MAX_PAGES = 100;
    const PAGE_DELAY_MS = 60;            // delay between collection page fetches
    const TABLE_READY_TIMEOUT_MS = 20000;
    const IS_FORUM_HEALTH_CUSTOMER = Boolean(window.isForumHealthCustomer);
  
    // After main pass, do a few delayed sweeps to catch late rows
    const SWEEP_SCHEDULE_MS = [300, 1000, 3000, 7000];
  
    // Debounce window for refreshes triggered by UI interactions
    const REFRESH_DEBOUNCE_MS = 200;
  
    /************ LOG ************/
    const LOG  = (...a) => console.log('[WOF]', ...a);
    const WARN = (...a) => console.warn('[WOF]', ...a);
  
    /************ UTILS ************/
    const sleep = (ms) => new Promise(r => setTimeout(r, ms));
    const stripRetailPrefix = s => (s || '').replace(/^Retail:\s*/i, '').trim();
  
    function debounce(fn, wait) {
      let t = null;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn(...args), wait);
      };
    }
  
    // strong normalization (handles ®/™, accents, punctuation)
    function toAsciiBasic(s) {
      return (s || '')
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')   // diacritics
        .replace(/[™®]/g, '')              // trademark symbols
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
    }
    const normalizeStrict = (s) => toAsciiBasic(s);
    function normalizeFuzzy(s) {
      return toAsciiBasic(s)
        .replace(/&/g, ' and ')
        .replace(/[^\p{L}\p{N}\s]/gu, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    }
  
    async function waitForTableReady(timeoutMs = TABLE_READY_TIMEOUT_MS) {
      LOG('Waiting for table & at least one row…');
      const start = Date.now();
      while (Date.now() - start < timeoutMs) {
        const table = document.querySelector(TARGET_TABLE);
        const headerRow = table?.querySelector('thead tr');
        const hasRow = !!table?.querySelector('tbody tr');
        if (table && headerRow && hasRow) {
          LOG('Table ready.');
          return true;
        }
        await sleep(150);
      }
      WARN('Timed out waiting for table.');
      return false;
    }
  
    /************ TABLE HELPERS ************/
    function ensureRetailHeader() {
      const table = document.querySelector(TARGET_TABLE);
      if (!table) return false;
      const headerRow = table.querySelector('thead tr');
      if (!headerRow) return false;
  
      if (!headerRow.querySelector('#wof_retail_price_header')) {
        const th = document.createElement('th');
        th.id = 'wof_retail_price_header';
        th.textContent = 'Retail Price';
        // prefer to insert after the Price header if present
        const priceHeader = headerRow.querySelector('#wof_price_header');
        if (priceHeader) priceHeader.insertAdjacentElement('afterend', th);
        else headerRow.appendChild(th);
        LOG('Inserted Retail Price header.');
      }
      return true;
    }
  
    // Insert a retail <td> right after the actual Price cell
    function ensureRetailCellForRow(row) {
      if (!row || row.querySelector('td.wof_retail_price')) return false;
  
      const priceSpan = row.querySelector('.wof-price');
      const td = document.createElement('td');
      td.className = 'wof_retail_price';
  
      if (priceSpan) {
        const priceTd = priceSpan.closest('td');
        if (priceTd) {
          priceTd.insertAdjacentElement('afterend', td);
          return true;
        }
      }
      // Fallback: append at end if we couldn’t find price td
      row.appendChild(td);
      return true;
    }
  
    function ensureRetailCellsForAllRows() {
      const table = document.querySelector(TARGET_TABLE);
      if (!table) return 0;
      let added = 0;
      table.querySelectorAll('tbody tr').forEach(row => {
        if (ensureRetailCellForRow(row)) added++;
      });
      if (added) LOG(`ensureRetailCellsForAllRows: ensured +${added} retail td(s).`);
      return added;
    }

    function applyManufacturerVisibility() {
      const table = document.querySelector(TARGET_TABLE);
      if (!table) return;
      const headerRow = table.querySelector('thead tr');
      if (!headerRow) return;
      const headers = Array.from(headerRow.children);
      const targetTh = headers.find(th => {
        const txt = (th.textContent || '').trim().toLowerCase();
        return txt.includes('manufacturer') || txt.includes('product type');
      });
      if (!targetTh) return;
      const targetIndex = headers.indexOf(targetTh);
      const displayValue = IS_FORUM_HEALTH_CUSTOMER ? '' : 'none';
      targetTh.style.setProperty('display', displayValue, 'important');
      table.querySelectorAll('tbody tr').forEach(row => {
        const cell = row.children[targetIndex];
        if (cell) cell.style.setProperty('display', displayValue, 'important');
      });
      if (!IS_FORUM_HEALTH_CUSTOMER) {
        table.classList.add('wof-hide-product-type');
        const styleId = 'wof-hide-product-type-style';
        if (!document.getElementById(styleId)) {
          const style = document.createElement('style');
          style.id = styleId;
          style.textContent = `
#wof_product_table.wof-hide-product-type th:nth-child(${targetIndex + 1}),
#wof_product_table.wof-hide-product-type td:nth-child(${targetIndex + 1}) { display: none !important; }
`;
          document.head.appendChild(style);
        }
      } else {
        table.classList.remove('wof-hide-product-type');
      }
    }
  
    function fillRowIfBlank(row, maps) {
      const titleEl = row.querySelector('.product-title-td .wof-product-title');
      const retailTd = row.querySelector('td.wof_retail_price');
      if (!titleEl || !retailTd) return false;
  
      // already filled?
      if (retailTd.textContent && retailTd.textContent.trim() !== '') return false;
  
      const keyStrict = normalizeStrict(titleEl.textContent);
      const keyFuzzy  = normalizeFuzzy(titleEl.textContent);
  
      const val = maps.strict.get(keyStrict) || maps.fuzzy.get(keyFuzzy);
      if (val) {
        retailTd.textContent = val;          // e.g. "$34.97"
        retailTd.dataset.retailPrice = val;
        return true;
      }
      return false;
    }
  
    function fillAllRows(maps) {
      const table = document.querySelector(TARGET_TABLE);
      if (!table) return { filled: 0, blanks: 0 };
      let filled = 0, blanks = 0;
      table.querySelectorAll('tbody tr').forEach(row => {
        if (!fillRowIfBlank(row, maps)) {
          const td = row.querySelector('td.wof_retail_price');
          if (td && (!td.textContent || !td.textContent.trim())) blanks++;
        } else {
          filled++;
        }
      });
      if (filled) LOG(`Fill pass: +${filled} cells.`);
      return { filled, blanks };
    }
  
    /************ COLLECTION SCRAPE ************/
    async function fetchCollectionDoc(urlRelative) {
      // forward current query params (password/preview keys)
      const base = new URL(urlRelative, location.origin);
      const current = new URL(location.href);
      current.searchParams.forEach((v, k) => {
        if (!base.searchParams.has(k)) base.searchParams.set(k, v);
      });
      const finalRel = base.pathname + '?' + base.searchParams.toString();
  
      const res = await fetch(finalRel, { cache: 'no-store', credentials: 'same-origin' });
      LOG('HTTP', res.status, finalRel);
      if (!res.ok) return null;
      const html = await res.text();
      return new DOMParser().parseFromString(html, 'text/html');
    }
  
    function extractCards(doc) {
      const set = new Set();
      doc.querySelectorAll('.card').forEach(el => set.add(el));
      doc.querySelectorAll('template').forEach(tpl => {
        const c = tpl.content;
        if (c) c.querySelectorAll('.card').forEach(el => set.add(el));
      });
      const arr = Array.from(set);
      LOG('extractCards: found', arr.length);
      return arr;
    }
  
    function mapTitlesToRetail(cards) {
      const strict = new Map();
      const fuzzy  = new Map();
      let count = 0;
      cards.forEach(card => {
        const titleEl =
          card.querySelector('.card__heading a.full-unstyled-link') ||
          card.querySelector('h3.card__heading.h5 a');
        const retailEl = card.querySelector('.price-item--retail');
        if (!titleEl || !retailEl) return;
  
        const title = titleEl.textContent;
        const clean = stripRetailPrefix(retailEl.textContent.replace(/\s+/g, ' ').trim());
        if (!title || !clean) return;
  
        strict.set(normalizeStrict(title), clean);
        fuzzy.set(normalizeFuzzy(title), clean);
        count++;
      });
      LOG('mapTitlesToRetail: mapped', count);
      return { strict, fuzzy };
    }
  
    /************ STATE ************/
    const strictMap = new Map();
    const fuzzyMap  = new Map();
  
    // Try an immediate hide once on script load (covers cases before main init)
    applyManufacturerVisibility();

    // Debounced refresh that re-injects header/cells and tries to fill rows
    const debouncedRefresh = debounce(() => {
      ensureRetailHeader();
      ensureRetailCellsForAllRows();
      fillAllRows({ strict: strictMap, fuzzy: fuzzyMap });
      applyManufacturerVisibility();
    }, REFRESH_DEBOUNCE_MS);
  
    /************ MAIN POPULATE ************/
    async function progressivePopulate() {
      LOG('Starting progressive populate…');
      const ready = await waitForTableReady();
      if (!ready) { WARN('Table never became ready. Aborting.'); return; }
  
      // Ensure header/cells before any fills
      ensureRetailHeader();
      ensureRetailCellsForAllRows();
      applyManufacturerVisibility();
  
      // Crawl collection pages and build maps progressively
      for (let page = 1; page <= MAX_PAGES; page++) {
        const doc = await fetchCollectionDoc(`${COLLECTION_BASE}?page=${page}`);
        if (!doc) { WARN('Stopping: fetch failed at page', page); break; }
  
        const cards = extractCards(doc);
        LOG(`Page ${page}: cards=${cards.length}`);
        if (!cards.length) { LOG('Stopping: no cards on page', page); break; }
  
        const maps = mapTitlesToRetail(cards);
        maps.strict.forEach((v, k) => strictMap.set(k, v));
        maps.fuzzy.forEach((v, k)  => fuzzyMap.set(k, v));
  
        // Refresh current table after each page batch
        ensureRetailCellsForAllRows();
        fillAllRows({ strict: strictMap, fuzzy: fuzzyMap });
        applyManufacturerVisibility();
  
        await sleep(PAGE_DELAY_MS);
      }
  
      LOG('Populate complete. Titles in map:', strictMap.size);
    }
  
    /************ SWEEPS & OBSERVERS ************/
    function scheduleSweeps() {
      SWEEP_SCHEDULE_MS.forEach((ms) => {
        setTimeout(() => {
          LOG(`Sweep @ ${ms}ms`);
          ensureRetailHeader();
          ensureRetailCellsForAllRows();
          fillAllRows({ strict: strictMap, fuzzy: fuzzyMap });
          applyManufacturerVisibility();
        }, ms);
      });
    }
  
    // Observe the table body for appended/removed rows and re-fill on change
    let tableObserver = null;
    function bindTableObserver() {
      const table = document.querySelector(TARGET_TABLE);
      const tbody = table?.querySelector('tbody');
      if (!tbody) return;
  
      if (tableObserver) { try { tableObserver.disconnect(); } catch(_){} tableObserver = null; }
  
      tableObserver = new MutationObserver((mutations) => {
        let rowsChanged = false;
        for (const m of mutations) {
          if (m.type === 'childList' && (m.addedNodes.length || m.removedNodes.length)) {
            rowsChanged = true; break;
          }
        }
        if (rowsChanged) {
          LOG('Table rows changed (observer); refreshing retail cells…');
          debouncedRefresh();
        }
      });
  
      tableObserver.observe(tbody, { childList: true, subtree: false });
    }
  
    /************ UI TRIGGERS ************/
    function bindUITriggers() {
      // Search: form submit
      const searchForm = document.getElementById('search_input_wrapper');
      if (searchForm) {
        searchForm.addEventListener('submit', async () => {
          LOG('Search form submitted; refreshing…');
          // Let UI render results first
          await sleep(300);
          debouncedRefresh();
        });
      }
  
      // Search: search icon click (in case it triggers results without submit)
      const searchIcon = document.getElementById('wof_search_icon');
      if (searchIcon) {
        searchIcon.addEventListener('click', async () => {
          LOG('Search icon clicked; refreshing…');
          await sleep(300);
          debouncedRefresh();
        });
      }
  
      // Sort radio change
      document.querySelectorAll('.sort-by-option input[type="radio"]').forEach(radio => {
        radio.addEventListener('change', async () => {
          LOG(`Sort changed -> ${radio.value}; refreshing…`);
          await sleep(300);
          debouncedRefresh();
        }, { passive: true });
      });
  
      // Collection filters click
      document.querySelectorAll('.collection-filter').forEach(filter => {
        filter.addEventListener('click', async () => {
          LOG(`Collection filter clicked ("${filter.textContent.trim()}"); refreshing…`);
          await sleep(300);
          debouncedRefresh();
        }, { passive: true });
      });
  
      // “Show More” pagination button
      const btn = document.getElementById('showMoreProducts');
      if (btn) {
        let busy = false;
        btn.addEventListener('click', async () => {
          if (busy) return;
          busy = true;
          LOG('showMoreProducts clicked; waiting for new rows…');
          await sleep(600);
          debouncedRefresh();
          busy = false;
          LOG('showMoreProducts handled.');
        }, { passive: true });
      }
    }
  
    /************ PUBLIC API (optional) ************/
    window.WOF_RETAIL = {
      refresh: () => {
        LOG('Manual refresh() called');
        ensureRetailHeader();
        ensureRetailCellsForAllRows();
        fillAllRows({ strict: strictMap, fuzzy: fuzzyMap });
      }
    };
  
    /************ BOOT ************/
    (async function main() {
      await progressivePopulate();
      scheduleSweeps();
      bindTableObserver();
      bindUITriggers();
      LOG('Ready: progressive fills, sweeps, observer + UI triggers active.');
    })();
  })();
  
  /* =======================================
     DESC POPUP WATCHER (moves product link)
     ======================================= */
  (function () {
    // Restart cleanly if already running
    if (window.DESC_POPUP_WATCH?.stop) window.DESC_POPUP_WATCH.stop();
  
    const LOG  = (...a) => console.log('[DESC]', ...a);
    const WARN = (...a) => console.warn('[DESC]', ...a);
  
    // IDs used for moving the action link/button
    const POPUP_ID   = 'desc_popup';
    const WRAPPER_ID = 'desc_main_container'; // keep consistent with your DOM
    const ACTION_ID  = 'desc_action';
  
    // strict match: only count display === 'block'
    const STRICT_BLOCK = true;
  
    function isVisible(el) {
      if (!el || !el.isConnected) return false;
      const cs = getComputedStyle(el);
      if (!cs) return false;
      return STRICT_BLOCK ? cs.display === 'block' : cs.display !== 'none';
    }
  
    function moveActionToTop() {
      const wrapper = document.getElementById(WRAPPER_ID);
      const action  = document.getElementById(ACTION_ID);
      action.removeAttribute('target');
      if (!wrapper) { WARN(`Wrapper #${WRAPPER_ID} not found.`); return; }
      if (!action)  { WARN(`Action  #${ACTION_ID} not found.`);  return; }
      try {
        if (wrapper.firstChild !== action) {
          wrapper.insertBefore(action, wrapper.firstChild);
          LOG(`Moved #${ACTION_ID} to top of #${WRAPPER_ID}.`);
        }
      } catch (e) {
        WARN('Error moving action:', e);
      }
    }
  
    const state = {
      el: null,
      lastVisible: false,
      attrObs: null,
      visInterval: null,
      domObs: null,
      existInterval: null,
    };
  
    function unbindNode() {
      if (state.attrObs) { try { state.attrObs.disconnect(); } catch(_){} state.attrObs = null; }
      if (state.visInterval) { clearInterval(state.visInterval); state.visInterval = null; }
      state.el = null;
      state.lastVisible = false;
    }
  
    function tickVisibility(reason) {
      const el = state.el;
      if (!el || !el.isConnected) return;
      const now = isVisible(el);
  
      if (now !== state.lastVisible) {
        state.lastVisible = now;
        if (now) {
          LOG(`desc_popup SHOW (${reason})`);
          moveActionToTop();
        } else {
          LOG(`desc_popup HIDE (${reason})`);
        }
      }
    }
  
    function bindNode(el) {
      unbindNode();
      state.el = el;
      state.lastVisible = isVisible(el);
      LOG('Bound to #desc_popup. initialVisible =', state.lastVisible);
  
      // Attribute observer (style/class changes)
      state.attrObs = new MutationObserver(() => tickVisibility('attr'));
      state.attrObs.observe(el, { attributes: true, attributeFilter: ['style', 'class'] });
  
      // Computed-style poll (covers stylesheet changes)
      state.visInterval = setInterval(() => tickVisibility('interval'), 150);
  
      // Immediate check in case it's already shown
      tickVisibility('immediate');
    }
  
    function ensureBinding() {
      // If current node disappeared or got replaced, rebind
      const current = document.getElementById(POPUP_ID);
      if (current && current !== state.el) {
        bindNode(current);
      } else if (!current && state.el) {
        LOG('#desc_popup removed; waiting to rebind…');
        unbindNode();
      }
    }
  
    function start() {
      // Observe the whole document for node add/remove (fast rebind)
      state.domObs = new MutationObserver(() => ensureBinding());
      state.domObs.observe(document.documentElement, { childList: true, subtree: true });
  
      // Also poll existence in case mutations are suppressed
      state.existInterval = setInterval(ensureBinding, 200);
  
      // Bind immediately if present
      const el = document.getElementById(POPUP_ID);
      if (el) bindNode(el);
  
      LOG('DESC_POPUP_WATCH started.');
    }
  
    function stop() {
      unbindNode();
      if (state.domObs) { try { state.domObs.disconnect(); } catch(_){} state.domObs = null; }
      if (state.existInterval) { clearInterval(state.existInterval); state.existInterval = null; }
      LOG('DESC_POPUP_WATCH stopped.');
    }
  
    window.DESC_POPUP_WATCH = { start, stop };

    // auto-start
    start();
  })();

  /* =======================================
     WHOLESALE SIGNUP: move Phone into Primary Contact Details
     (/apps/wpdapp). The signup form's sections are separate CSS
     grids, so CSS `order` can't move Phone across sections — we
     relocate the field's DOM node instead.
     ======================================= */
  (function () {
    const PHONE_WRAPPER_ID  = 'wpdAddressPhoneWrapper';
    const PRIMARY_FIELDS_ID = 'wpdPrimaryContactFieldsWrapper';

    function movePhoneField() {
      const phone   = document.getElementById(PHONE_WRAPPER_ID);
      const primary = document.getElementById(PRIMARY_FIELDS_ID);
      if (!phone || !primary) return false;             // not the signup form page
      if (phone.parentElement === primary) return true; // already in place
      primary.appendChild(phone);                       // append after First name / Email / Title
      return true;
    }

    function init() {
      if (movePhoneField()) return;
      // The form may hydrate/re-render after load; watch briefly until both exist.
      const obs = new MutationObserver(() => {
        if (movePhoneField()) obs.disconnect();
      });
      obs.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(() => obs.disconnect(), 10000); // stop watching regardless after 10s
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  